import {
  ACTIONS,
  activity,
  AnalyticsEventPropTypes,
  AnalyticsEventWithControlName,
  eventDetailVersion
} from '@uma/react-commons/dist/index';
import { screenName, screenPath } from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';

export const ManageActiveSessionsHyperlinkClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageActiveSessionsLink',
    controlDetail: URLS.HpIdSecurity,
    version: eventDetailVersion
  };

export const ActiveSessionsError = (
  errorInfo: string
): AnalyticsEventPropTypes => {
  return {
    actionAuxParams: `error=${errorInfo}`,
    action: ACTIONS.MODULE_DISPLAYED,
    activity,
    screenPath,
    screenName: 'ActiveSessionsError',
    version: eventDetailVersion
  };
};
